export default "__VITE_ASSET__d0033e41__"